/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ScienceBranchDTO,
    ScienceBranchDTOFromJSON,
    ScienceBranchDTOFromJSONTyped,
    ScienceBranchDTOToJSON,
} from './ScienceBranchDTO';

/**
 * 
 * @export
 * @interface ScienceBranchDTOPagedResponse
 */
export interface ScienceBranchDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof ScienceBranchDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScienceBranchDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ScienceBranchDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ScienceBranchDTO>}
     * @memberof ScienceBranchDTOPagedResponse
     */
    data?: Array<ScienceBranchDTO> | null;
}

export function ScienceBranchDTOPagedResponseFromJSON(json: any): ScienceBranchDTOPagedResponse {
    return ScienceBranchDTOPagedResponseFromJSONTyped(json, false);
}

export function ScienceBranchDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScienceBranchDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ScienceBranchDTOFromJSON)),
    };
}

export function ScienceBranchDTOPagedResponseToJSON(value?: ScienceBranchDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ScienceBranchDTOToJSON)),
    };
}

